/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<6864c1cc9c15cbb63ad42f528c173d25>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType43 = {
  getVariation: function getVariation(n) {
    if (n === 1) {
      return IntlVariations.NUMBER_ONE;
    } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) {
      return IntlVariations.NUMBER_FEW;
    } else {
      return IntlVariations.NUMBER_MANY;
    }
  }
};
module.exports = IntlCLDRNumberType43;